import { UnderlinedTag } from "../../../components/UnderlinedTag";
import { getThemeForPath } from "../../../config/theme";

const SECTION_COLOUR = getThemeForPath("/steam/insights");

/**
 * Section wrapper for the insights page: underlined heading, optional
 * intro line, then content.
 */
export const InsightSection = ({ id, title, intro, actions, children }) => (
    <section id={id} className="mt-8 mb-8">
        <div className="mb-4 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
            <div>
                <h2 className="text-xl font-semibold text-gray-800">
                    <UnderlinedTag text={title} colorClass={SECTION_COLOUR} size="small" />
                </h2>
                {intro && <p className="mt-2 max-w-prose text-base leading-relaxed text-gray-700">{intro}</p>}
            </div>
            {actions && <div className="flex flex-col gap-3 sm:flex-row sm:items-end">{actions}</div>}
        </div>
        {children}
    </section>
);

export const Card = ({ children, className = "" }) => (
    <div className={`rounded-lg border border-gray-200 bg-white p-4 shadow-sm sm:p-6 ${className}`}>{children}</div>
);

/**
 * Loading / error / empty states shared by the insight panels.
 */
export const QueryState = ({ query, isEmpty = false, emptyText = "Nothing to show yet.", children }) => {
    if (query.isLoading) {
        return <p className="py-8 text-center text-sm text-gray-500">Loading…</p>;
    }
    if (query.isError) {
        return (
            <p className="py-8 text-center text-sm text-gray-500">
                Couldn't load this data. {query.error?.response?.data?.message || "Try again later."}
            </p>
        );
    }
    if (isEmpty) {
        return <p className="py-8 text-center text-sm text-gray-500">{emptyText}</p>;
    }
    return children;
};
